export default "__VITE_ASSET__BP5YbEWo__ 720w";